/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Lock_UnavailableInputs */

const en_landing_studio_lock_unavailable = /** @type {(inputs: Landing_Studio_Lock_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pixel Lock was skipped for this image (the result couldn't be read back). The raw edit is shown.`)
};

const zh_landing_studio_lock_unavailable = /** @type {(inputs: Landing_Studio_Lock_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本图未能应用像素锁定（无法读取结果），显示的是原始编辑结果。`)
};

/**
* | output |
* | --- |
* | "Pixel Lock was skipped for this image (the result couldn't be read back). The raw edit is shown." |
*
* @param {Landing_Studio_Lock_UnavailableInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_lock_unavailable = /** @type {((inputs?: Landing_Studio_Lock_UnavailableInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Lock_UnavailableInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_lock_unavailable(inputs)
	return zh_landing_studio_lock_unavailable(inputs)
});
export { landing_studio_lock_unavailable as "landing.studio.lock_unavailable" }